'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.LabelBase = exports.HyperLink = exports.TextLink = exports.TextDiv = exports.Paragraph = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  cursor: pointer;\n'], ['\n  color: ', ';\n  cursor: pointer;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  line-height: ', ';\n  user-select: none;\n'], ['\n  color: ', ';\n  line-height: ', ';\n  user-select: none;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theme = require('@hixme-ui/theme');

var _theme2 = _interopRequireDefault(_theme);

var _themeProps = require('@hixme-ui/theme-props');

var _TextBase = require('./TextBase');

var _TextBase2 = _interopRequireDefault(_TextBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = exports.Paragraph = _TextBase2.default.withComponent('p');
var TextDiv = exports.TextDiv = _TextBase2.default.withComponent('div');

var TextLink = exports.TextLink = _TextBase2.default.withComponent('a');
var HyperLink = exports.HyperLink = TextLink.extend(_templateObject, function (props) {
  return props.color || (0, _themeProps.getTextColor)(props, _theme2.default.textColors.darkBlue);
});

var LabelBase = exports.LabelBase = _TextBase2.default.withComponent('label');
var Label = exports.Label = LabelBase.extend(_templateObject2, function (props) {
  return props.color || (0, _themeProps.getTextColor)(props, '#394651');
}, function (props) {
  return props.lineHeight || '19px';
});

var Text = function Text(_ref) {
  var a = _ref.a,
      div = _ref.div,
      label = _ref.label,
      p = _ref.p,
      props = (0, _objectWithoutProperties3.default)(_ref, ['a', 'div', 'label', 'p']);

  var Tag = _TextBase2.default;

  if (a || props.href) {
    Tag = HyperLink;
  } else if (p) {
    Tag = Paragraph;
  } else if (div) {
    Tag = TextDiv;
  } else if (label) {
    Tag = Label;
  }

  return _react2.default.createElement(Tag, props);
};

Text.displayName = 'hui:Text';
Text.huiName = 'Text';

Text.propTypes = {
  a: _propTypes2.default.bool,
  div: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  label: _propTypes2.default.bool,
  p: _propTypes2.default.bool
};
Text.defaultProps = {
  a: false,
  div: false,
  href: null,
  label: false,
  p: false
};

exports.default = Text;
//# sourceMappingURL=Text.js.map


//////////////////
// WEBPACK FOOTER
// ../text/lib/Text.js
// module id = 343
// module chunks = 0